import { UploadIcon } from "@solomon-apps/shared";
import React from "react";

import type { ChartDataPoint } from "../data/chartData";
import { formatCurrencyFull } from "../utils/formatters";

import { ChartArea } from "./ChartArea";

export interface ChartCardProps {
    title: string;
    data: ChartDataPoint[];
    kpiValue: number;
    formatter: (value: number) => string;
    onShare: () => void;
}

export function ChartCard({
    title,
    data,
    kpiValue,
    formatter,
    onShare
}: ChartCardProps): React.ReactElement {
    return (
        <div className="relative bg-m-surface-base">
            <button
                onClick={onShare}
                className="absolute top-4 right-3 md:top-6 md:right-6 w-8 h-8 flex items-center justify-center transition-colors text-gray-400 hover:text-m-accent cursor-pointer"
                aria-label={`Share ${title}`}
                title="Share"
            >
                <UploadIcon />
            </button>
            <div className="md:px-6 md:pt-6 pb-4 px-3 pt-3">
                <h2 className="text-base lg:text-lg text-foreground mb-1">
                    {title}
                </h2>
                <p
                    className="text-2xl lg:text-3xl text-m-accent mb-4"
                    style={{ fontFamily: '"APK Narrative"' }}
                >
                    {formatCurrencyFull(kpiValue)}
                </p>
            </div>
            <div className="pl-1 md:pl-3 pr-4 lg:pr-2 pb-2 md:pb-5">
                <ChartArea title={title} data={data} formatter={formatter} />
            </div>
        </div>
    );
}
